import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import './Features.css';


const Features = () => {
	return (
		<div className="features-cont">
			<h2 className="section-header">Features</h2>
			<Container>
				<Row className="features-items">
					<Col md={3}>
						<Card
							style={{
								backgroundColor: "pink",
								borderRadius: "10px",
								padding: "20px",
								margin: "20px",
								boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
								transition: "transform 0.3s ease-in-out",
							}}>
							<h3>Personalized Learning Paths</h3>
							<p>
								Learn Your Way leverages advanced AI algorithms to assess your
								current skill level and learning pace.
							</p>
						</Card>
					</Col>
					<Col md={3}>
						<Card
							style={{
								backgroundColor: "pink",
								borderRadius: "10px",
								padding: "20px",
								margin: "20px",
								
								boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
								transition: "transform 0.3s ease-in-out",
							}}>
							
								<h3>Real-time Course Design</h3>
								<p>
									Our AI system continuously evaluates your progress and adjusts
									the course content in real-time.
								</p>
							
						</Card>
					</Col>
					<Col md={3}>
						<Card
							style={{
								backgroundColor: "pink",
								borderRadius: "10px",
								padding: "20px",
								margin: "20px",
								boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
								transition: "transform 0.3s ease-in-out",
							}}>
							<h3>Optimized Time Management</h3>
							<p>
								We understand the value of your time. Learn Your Way optimizes
								your training schedule.
							</p>
						</Card>
					</Col>
					<Col md={3}>
						<Card
							style={{
								backgroundColor: "pink",
								borderRadius: "10px",
								padding: "20px",
								margin: "20px",
								
								boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
								transition: "transform 0.3s ease-in-out",
							}}>
							<h3>Skill Assessments & Progress Tracking</h3>
							<p>
								Track your progress effortlessly with our integrated assessment
								tools helping you focus your efforts where they matter most.
							</p>
						</Card>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default Features;
